<template>
    <div id="app">
        <template>
            <router-view></router-view>
        </template>
    </div>
</template>
<script>
// import store from "./vuex/store";
export default {
  data() {
    return {
    }
  }
}
</script>
<style lang="less">
@import './assets/css/main.less';
</style>



// WEBPACK FOOTER //
// src/App.vue